// import React from "react";
// import ReactDOM from "react-dom/client";
// import "./index.css";
// import App from "./App";
// import { BrowserRouter } from "react-router-dom";

// import { MantineProvider } from "@mantine/core";

// import "@mantine/core/styles.css";

// const root = ReactDOM.createRoot(document.getElementById("root"));
// root.render(
//   <MantineProvider>
//     <BrowserRouter>
//       <App />
//     </BrowserRouter>
//   </MantineProvider>
// );

// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { AuthProvider } from "./context/AuthContext";
import { MantineProvider } from "@mantine/core";
import "@mantine/core/styles.css";
import "stream-chat-react/dist/css/v2/index.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./index.css";

if ("serviceWorker" in navigator && "PushManager" in window) {
  window.addEventListener("load", async () => {
    try {
      const swParams = new URLSearchParams({
        apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "",
        authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "",
        projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "",
        storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "",
        messagingSenderId:
          process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "",
        appId: process.env.REACT_APP_FIREBASE_APP_ID || "",
        measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "",
      });
      await navigator.serviceWorker.register(
        `/firebase-messaging-sw.js?${swParams.toString()}`,
      );
    } catch (error) {
      console.error("ServiceWorker registration failed:", error);
    }
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <MantineProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </MantineProvider>
    </AuthProvider>
  </React.StrictMode>,
);
